import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface UnfollowModal {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  userName: string | undefined
}

export function UnfollowModal({
  open,
  onClose,
  onConfirm,
  userName,
}: UnfollowModal) {
  return (
    <AlertDialog open={open} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unfollow</AlertDialogTitle>
          <AlertDialogDescription>
            By unfollowing you will no longer get updates through notification
            from "{userName}"
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="!bg-transparent !text-gray-600 hover:!bg-gray-100 !border-none">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Unfollow
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
